import * as React from 'react'
import HorizontalSelectorItem from '../HorizontalSelectorItem'
import HorizontalSelector from '../HorizontalSelector'
import { RouteComponentProps } from 'react-router'
import { Link } from 'react-router-dom'
import UIMessages from 'src/utils/ui-messages'

interface ITableToggleProps extends RouteComponentProps<any> {
  selected: string
}

class TableToggle extends React.Component<ITableToggleProps, any> {
  public render() {
    const active = !/\/deactivated/.test(location.pathname)
    return (
      <div className='ml2'>
        <HorizontalSelector>
          <HorizontalSelectorItem isSelected={active}>
            <Link to={`/vehicles`}>
              <div>{UIMessages.vehicle.VEHICLES}</div>
            </Link>
          </HorizontalSelectorItem>
          &nbsp;
          <HorizontalSelectorItem isSelected={!active}>
            <Link to={`/vehicles/deactivated`}>
              <div>{UIMessages.vehicle.DEACTIVATED_VEHICLES}</div>
            </Link>
          </HorizontalSelectorItem>
        </HorizontalSelector>
      </div>
    )
  }
}

export default TableToggle



// WEBPACK FOOTER //
// ./src/components/vehicles/TableToggle.tsx